{
  "optionsBoardHeader": {
    "types": {
      "call": "Call",
      "put": "Put"
    },
    "datesExpirations": {
      "errorFetch": "Unable to retrieve expiration dates"
    }
  }
}
